import React, { useEffect } from 'react'
import sfAuthService from '../app/services/sfAuth/SFAuthService'
import { Dialog, DialogActions, DialogContent, Button } from '@mui/material'
import { DialogTitleWithIconClose } from './views/common-components/DialogTitleWithIconClose'
import { Trans } from '@lingui/macro'

export default function InactivityDetector () {
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [redirecting, setRedirecting] = React.useState(false)
  const timeoutInMiliseconds = 3600000
  let timeoutId

  useEffect(() => {
    document.addEventListener('mousemove', resetTimer, false)
    document.addEventListener('mousedown', resetTimer, false)
    document.addEventListener('keypress', resetTimer, false)
    document.addEventListener('wheel', resetTimer, false)
    startTimer()
    return () => {
      document.removeEventListener('mousemove', resetTimer, false)
      document.removeEventListener('mousedown', resetTimer, false)
      document.removeEventListener('keypress', resetTimer, false)
      document.removeEventListener('wheel', resetTimer, false)
    }
  }, [])

  function resetTimer () {
    window.clearTimeout(timeoutId)
    if (!dialogOpen) {
      startTimer()
    }
  }

  function startTimer () {
    timeoutId = window.setTimeout(handleInactivity, timeoutInMiliseconds)
  }

  function handleInactivity () {
    setDialogOpen(true)
    // sfAuthService.setUser(null)
    window.clearTimeout(timeoutId)
  }

  function logout () {
    setRedirecting(true)
    sfAuthService.setUser(null)
    sfAuthService.logout().then(
      r => {
        sfAuthService.doLogin({})
        window.location.reload(true)
      },
      reject => {
        window.location.reload(true)
      }
    )
  }

  return (
    <Dialog open={dialogOpen} fullWidth maxWidth='xs'>
      <DialogTitleWithIconClose
        label={<Trans>INACTIVITY_DETECTOR_DIALOG_TITLE</Trans>}
        handleClose={logout}
        disabled={false}
      />
      <DialogContent sx={{ padding: '32px 48px 0 48px' }}>
        <span>
          <Trans>
            You have been inactive for 1 hour and automatically logged out
          </Trans>
        </span>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '32px',
          padding: '0 48px 48px 48px'
        }}
      >
        <Button
          disabled={redirecting}
          variant='outlined'
          color='primary'
          onClick={logout}
          fullWidth
        >
          <Trans>INACTIVITY_DETECTOR_BUTTON_LABEL</Trans>
        </Button>
      </DialogActions>
    </Dialog>
  )
}
